import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  TextField,
  Paper,
  Divider,
  Box,
  IconButton,
  Autocomplete,
  Card,
  CardContent,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { getCustomerCards } from "../../api/customerCards/getCustomerCard";
import Swal from "sweetalert2";
import { getFinancialTransactionsForTaxpayer } from "../../api/financialTransactions/getFinancialTransactionsForTaxpayer";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import SearchIcon from "@mui/icons-material/Search";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTR from "../../locale.tr";
import EditFinancialTransactionModal from "./editTransaction";
import { Add, Delete, Edit } from "@mui/icons-material";
import {
  deleteFinancialTransaction,
  deleteForFinancialTransaction,
} from "../../api/financialTransactions/deleteFinancialTransaction";
import { updateCustomerCard } from "../../api/customerCards/updateCustomerCard";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils";
import AutoTransactionForAccrual from "./autoTransactionForAccrual";
import { BankStatementModal } from "./bankStatementModal";
import { TypeOfActiviy } from "../../components/enums/enums";
const LedgerTypeOptions = [
  { value: "SAHIS_BILANCO", label: "Şahıs Bilançosu" },
  { value: "ISLETME", label: "İşletme" },
  { value: "TUZEL", label: "Tüzel" },
  { value: "SERBEST_MESLEK", label: "Serbest Meslek" },
  { value: "BASIT_USUL", label: "Basit Usul" },
];

const TaxpayerCardAndTransactions = ({
  open,
  onClose,
  taxpayerId,
  setModalOpenForTransaciton,
  searchForTransaction,
  setSearchForTransaction,
  taxpayerList,
}) => {
  const [rowData, setRowData] = useState([]);
  const [summary, setSummary] = useState({});

  const [pageSize, setPageSize] = useState(250);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    moment().startOf("year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [cardData, setCardData] = useState({
    city: "",
    district: "",
    email: [],
    mobilePhone: [],
    workPhone: [],
    listPrice: 0,
    netPrice: 0,
    vatRate: 20,
    ledgerType: null,
    activityType: [],
    note: "",
  });
  const [newEmail, setNewEmail] = useState("");
  const [newMobilePhone, setNewMobilePhone] = useState("");
  const [newWorkPhone, setNewWorkPhone] = useState("");
  const [columnDefs] = useState([
    {
      field: "date",
      headerName: "Tarih",
      sortable: true,
      filter: false,
      valueFormatter: (params) => {
        return moment(params.value).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      field: "documentType",
      headerName: "İşlem Türü",
      sortable: true,
      filter: true,
      minWidth: 140,
    },
    {
      field: "description",
      headerName: "Açıklama",
      sortable: true,
      filter: "agTextColumnFilter",
      flex: 1,
    },
    {
      field: "expense",
      headerName: "Harcama",
      sortable: true,
      filter: false,
      hide: true,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "collection",
      headerName: "Alınan",
      sortable: true,
      filter: false,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "accrual",
      headerName: "Borç",
      sortable: true,
      filter: false,
      valueFormatter: (params) => {
        return params.value.toFixed(2) + " ₺";
      },
      type: "numericColumn",
    },
    {
      field: "paymentType",
      headerName: "Ödeme Türü",
      sortable: true,
      filter: true,
    },
    {
      headerName: "İşlemler",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      cellRenderer: (params) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                setCurrentTransaction(params.data);
                setEditModalOpen(true);
              }}
              sx={{ minWidth: "40px", padding: "4px" }}
            >
              <Edit fontSize="small" />
            </Button>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => {
                handleDeleteTransaction(params.data.id);
              }}
              sx={{ minWidth: "40px", padding: "4px" }}
            >
              <Delete fontSize="small" />
            </Button>
          </Box>
        );
      },
    },
  ]);

  // Default Grid Options
  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        defaultExpanded: false,
        columnDefs: [{ field: "description" }],
        defaultColDef: {
          flex: 3,
          maxWidth: 300,
          resizable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPageNumber(newPage);
  };
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [autoAccrualModalOpen, setAutoAccrualModalOpen] = useState(false);
  const [bankStatementModalOpen, setBankStatementModalOpen] = useState(false);

  const [currentTransaction, setCurrentTransaction] = useState(null);
  const handleDeleteTransaction = async (transactionId) => {
    const result = await Swal.fire({
      title: "Silmek istediğinize emin misiniz?",
      text: "Bu işlemi geri alamazsınız!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Vazgeç",
    });

    if (result.isConfirmed) {
      try {
        await deleteForFinancialTransaction(transactionId);

        await Swal.fire({
          text: "Mükellef fişi silindi.",
          icon: "success",
          confirmButtonText: "Tamam",
          customClass: { container: ".swal-overlay" },
        });

        fetchFinancialTransactionsForTaxpayer();
      } catch (error) {
        console.error("Transaction deletion failed:", error);
        Swal.fire("Hata", "Silme işlemi başarısız oldu.", "error");
      }
    }
  };

  // Handle search button click
  const handleSearch = () => {
    fetchFinancialTransactionsForTaxpayer();
  };
  useEffect(() => {
    if (!searchForTransaction) {
      return;
    }
    handleSearch();
  }, [pageSize, pageNumber]);

  const handleSave = async () => {
    await updateCustomerCard(cardData)
      .then(() => {
        Swal.fire("Başarılı!", "Başarıyla Güncellendi.", "success");
      })
      .catch((resp) => {
        console.log(resp);
        Swal.fire(
          "Hata!",
          resp?.response?.data?.message ||
            "Mükellef Kartı bilgileri güncellenemedi.",
          "error"
        );
      });
  };

  useEffect(() => {
    if (searchForTransaction) {
      handleSearch();
    }
  }, [searchForTransaction]);
  const defaultColDef = useMemo(
    () => ({
      width: 90,
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      suppressMenu: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );
  const fetchCardData = async (id) => {
    try {
      const response = await getCustomerCards(id);
      setCardData(response.data);
    } catch (err) {
      Swal.fire({
        text:
          err.response?.data?.message || "Mükellef Kartı bilgileri alınamadı.",
        icon: "error",
        confirmButtonText: "Tamam",
        customClass: { container: ".swal-overlay" },
      });
    }
  };
  const fetchFinancialTransactionsForTaxpayer = async () => {
    setLoading(true);
    if (searchForTransaction) {
      setSearchForTransaction(false);
    }
    try {
      const response = await getFinancialTransactionsForTaxpayer(
        taxpayerId,
        startDate,
        endDate,
        pageSize,
        pageNumber
      );
      setSummary(response.data.summary);
      setRowData(response.data.data);
      setTotalCount(response.data.count);
      setTotalPages(Math.ceil(response.data.totalCount / pageSize) || 1);
    } catch (err) {
      Swal.fire({
        text:
          err.response?.data?.message || "Mükellef fiş bilgileri alınamadı.",
        icon: "error",
        confirmButtonText: "Tamam",
        customClass: { container: ".swal-overlay" },
      });
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCardData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    setCardData((prev) => ({ ...prev, [name]: Number(value) }));
  };

  const handleLedgerTypeChange = (event, newValue) => {
    setCardData((prev) => ({ ...prev, ledgerType: newValue?.value || null }));
  };
  const handleActivityTypeChange = (event, newValue) => {
    setCardData((prev) => ({
      ...prev,
      activityType: newValue.map((item) => item.value),
    }));
  };

  const addArrayItem = (field, value) => {
    if (!value.trim()) return;

    setCardData((prev) => ({
      ...prev,
      [field]: [...prev[field], value],
    }));

    // Clear input field
    if (field === "email") setNewEmail("");
    else if (field === "mobilePhone") setNewMobilePhone("");
    else if (field === "workPhone") setNewWorkPhone("");
  };

  const removeArrayItem = (field, index) => {
    setCardData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    if (taxpayerId && open) {
      fetchCardData(taxpayerId);
      fetchFinancialTransactionsForTaxpayer();
    }
  }, [taxpayerId, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Firma Kartı ve Fişler
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ height: "70vh", padding: 0 }}>
        <Grid container spacing={0} sx={{ height: "100%" }}>
          {/* Left side - Card (1/4) with scroll */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{ height: "100%", borderRight: "1px solid #e0e0e0" }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Scrollable content */}
              <Box
                sx={{
                  flexGrow: 1,
                  overflow: "auto",
                  px: 2,
                  py: 1,
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Mükellef Bilgileri
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Ünvan:{" "}
                  {taxpayerList.find((t) => t.id === taxpayerId)?.title ||
                    "Bilinmiyor"}
                </Typography>
                <Divider sx={{ my: 2 }} />

                <Box sx={{ mb: 2 }}>
                  <Autocomplete
                    options={LedgerTypeOptions}
                    getOptionLabel={(option) => option.label}
                    value={
                      LedgerTypeOptions.find(
                        (option) => option.value === cardData.ledgerType
                      ) || null
                    }
                    onChange={handleLedgerTypeChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Defter Türü"
                        size="small"
                        margin="dense"
                      />
                    )}
                  />
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Autocomplete
                    multiple
                    options={TypeOfActiviy}
                    getOptionLabel={(option) => option.label}
                    value={TypeOfActiviy.filter((opt) =>
                      cardData.activityType?.includes(opt.value)
                    )}
                    onChange={handleActivityTypeChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Faaliyet Türü" />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="Resmi Fiyatı"
                    name="listPrice"
                    type="number"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={cardData.listPrice}
                    onChange={handleNumericChange}
                    InputProps={{
                      endAdornment: (
                        <Typography variant="caption">₺</Typography>
                      ),
                    }}
                  />
                </Box>

                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="Reel Fiyat"
                    name="netPrice"
                    type="number"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={cardData.netPrice}
                    onChange={handleNumericChange}
                    InputProps={{
                      endAdornment: (
                        <Typography variant="caption">₺</Typography>
                      ),
                    }}
                  />
                </Box>

                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="KDV Oranı"
                    name="vatRate"
                    type="number"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={cardData.vatRate}
                    onChange={handleNumericChange}
                    InputProps={{
                      endAdornment: (
                        <Typography variant="caption">%</Typography>
                      ),
                    }}
                  />
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom>
                    E-posta Adresleri
                  </Typography>
                  {cardData.email.map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <TextField
                        size="small"
                        fullWidth
                        value={email}
                        disabled
                        variant="outlined"
                      />
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => removeArrayItem("email", index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Yeni e-posta"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                    />
                    <IconButton
                      color="primary"
                      onClick={() => addArrayItem("email", newEmail)}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom>
                    Cep Telefonu
                  </Typography>
                  {cardData.mobilePhone.map((phone, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <TextField
                        size="small"
                        fullWidth
                        value={phone}
                        disabled
                        variant="outlined"
                      />
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => removeArrayItem("mobilePhone", index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Yeni numara"
                      value={newMobilePhone}
                      onChange={(e) => setNewMobilePhone(e.target.value)}
                    />
                    <IconButton
                      color="primary"
                      onClick={() =>
                        addArrayItem("mobilePhone", newMobilePhone)
                      }
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom>
                    İş Telefonu
                  </Typography>
                  {cardData.workPhone.map((phone, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <TextField
                        size="small"
                        fullWidth
                        value={phone}
                        disabled
                        variant="outlined"
                      />
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => removeArrayItem("workPhone", index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Yeni numara"
                      value={newWorkPhone}
                      onChange={(e) => setNewWorkPhone(e.target.value)}
                    />
                    <IconButton
                      color="primary"
                      onClick={() => addArrayItem("workPhone", newWorkPhone)}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="Şehir"
                    name="city"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={cardData.city}
                    onChange={handleChange}
                  />
                </Box>

                <Box sx={{ mb: 2 }}>
                  <TextField
                    label="İlçe"
                    name="district"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={cardData.district}
                    onChange={handleChange}
                  />
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box
                  sx={{
                    height: 195,
                    overflow: "auto", // scroll için
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    p: 1,
                  }}
                >
                  <TextField
                    label="Not"
                    name="note"
                    multiline
                    fullWidth
                    rows={7}
                    variant="outlined"
                    value={cardData.note}
                    onChange={handleChange}
                    InputProps={{
                      sx: {
                        height: "100%",
                        overflow: "auto",
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Fixed bottom buttons */}
              <Box
                sx={{
                  borderTop: "1px solid #e0e0e0",
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleSave}
                >
                  Kaydet
                </Button>
                <Button variant="outlined" size="small" onClick={onClose}>
                  Kapat
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Right side - Grid (3/4) */}
          <Grid item xs={12} md={9} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Header */}
              <Box sx={{ p: "0px 7px 1px 7px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    m: 1,
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    İşlem Geçmişi
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setBankStatementModalOpen(true);
                    }}
                  >
                    Ekstre
                  </Button>
                  {bankStatementModalOpen && (
                    <BankStatementModal
                      taxpayerId={Number(taxpayerId)}
                      open={bankStatementModalOpen}
                      onClose={() => setBankStatementModalOpen(false)}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  )}
                </Box>

                <Divider sx={{ mb: 2 }} />
                {/* Özet Alanı */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                    padding: "5px 10px",
                    mb: 2,
                    height: "40px",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Borç:{" "}
                      <span style={{ color: "#1976d2" }}>
                        {(summary?.accrual ?? 0).toFixed(2)} ₺
                      </span>
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Harcama:{" "}
                      <span style={{ color: "#d32f2f" }}>
                        {(summary?.expense ?? 0).toFixed(2)} ₺
                      </span>
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Alınan:{" "}
                      <span style={{ color: "#388e3c" }}>
                        {(summary?.collection ?? 0).toFixed(2)} ₺
                      </span>
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Bakiye:{" "}
                    <span
                      style={{
                        color:
                          (summary?.bakiye ?? 0) >= 0 ? "#388e3c" : "#d32f2f",
                      }}
                    >
                      {(summary?.bakiye ?? 0).toFixed(2)} ₺
                    </span>
                  </Typography>
                </Box>

                {/* Date Range Picker and Search Button */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="Başlangıç Tarihi"
                        value={moment(startDate)}
                        onChange={(newValue) => {
                          setStartDate(newValue.format("YYYY-MM-DD"));
                        }}
                        slotProps={{ textField: { size: "small" } }}
                        sx={{ width: 160 }}
                      />

                      <DatePicker
                        label="Bitiş Tarihi"
                        value={moment(endDate)}
                        onChange={(newValue) => {
                          setEndDate(newValue.format("YYYY-MM-DD"));
                        }}
                        slotProps={{ textField: { size: "small" } }}
                        sx={{ width: 160 }}
                      />
                    </LocalizationProvider>

                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<SearchIcon />}
                      onClick={() => {
                        setPageNumber(1);
                        handleSearch();
                      }}
                    >
                      Ara
                    </Button>
                    {/* <Button>Ekstre Raporu Oluştur</Button> */}
                  </Box>
                  <Box>
                    <Button
                      variant="contained"
                      onClick={() => setAutoAccrualModalOpen(true)}
                      startIcon={<Add />}
                      sx={{
                        backgroundColor: "#5e35b1", // Mor tonunda özel renk
                        "&:hover": {
                          backgroundColor: "#4527a0", // Hover durumunda daha koyu mor
                        },
                        borderRadius: "8px",
                        textTransform: "none",
                        fontWeight: 500,
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      }}
                    >
                      Otomatik Aylık Tahakkuk Ekle
                    </Button>

                    <AutoTransactionForAccrual
                      taxpayerId={Number(taxpayerId)}
                      handleSearch={handleSearch}
                      open={autoAccrualModalOpen}
                      onClose={setAutoAccrualModalOpen}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "green" }}
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setModalOpenForTransaciton(true);
                      }}
                    >
                      Ekle
                    </Button>
                  </Box>
                </Box>
              </Box>

              {/* AG Grid */}
              <Box
                sx={{
                  flexGrow: 1,
                  px: 2,
                  pb: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  className="ag-theme-quartz"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    detailCellRendererParams={detailCellRendererParams}
                    animateRows={true}
                    localeText={localeTextTR}
                    rowSelection="multiple"
                    loading={loading}
                  />
                </div>
              </Box>

              {/* Pagination */}
              <Box
                sx={{
                  borderTop: "1px solid #e0e0e0",
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="body2">Sayfa Boyutu:</Typography>
                  <TextField
                    select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      setPageNumber(1); // Reset to first page when changing page size
                    }}
                    SelectProps={{
                      native: true,
                    }}
                    size="small"
                    sx={{ width: 90 }}
                  >
                    {[250, 500, 1000, 2500].map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </TextField>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography>Toplam Kayıt : {totalCount} </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Button
                    size="small"
                    disabled={pageNumber === 1}
                    onClick={() => handlePageChange(pageNumber - 1)}
                  >
                    Önceki
                  </Button>

                  <Typography variant="body2">
                    {pageNumber} / {totalPages}
                  </Typography>

                  <Button
                    size="small"
                    disabled={pageNumber === totalPages}
                    onClick={() => handlePageChange(pageNumber + 1)}
                  >
                    Sonraki
                  </Button>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
        {editModalOpen && (
          <EditFinancialTransactionModal
            open={editModalOpen}
            onClose={() => setEditModalOpen(false)}
            taxpayerList={taxpayerList}
            transactionData={currentTransaction}
            setSearchForTransaction={setSearchForTransaction}
            isCustomercard={true}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TaxpayerCardAndTransactions;
